import { makeStyles } from '@material-ui/core';

import {
  drawerWidth,
  transition,
} from '../../assets/jss/material-dashboard-pro-react';

export const useDashboardStyles = makeStyles(theme => ({
  fontFamily: 'Monstserrat',
  typography: {
    allVariants: {
      fontFamily: 'Montserrat',
    },
    fontFamily: 'Montserrat',
  },
  wrapper: {
    fontFamily     : 'Montserrat',
    backgroundColor: 'white',
    position       : 'relative',
    top            : '0',
    height         : '100vh',
    '&:after'      : {
      display: 'table',
      clear  : 'both',
      content: '" "',
    },
  },
  mainPanel: {
    fontFamily                  : 'Montserrat',
    transitionProperty          : 'top, bottom, width',
    transitionDuration          : '.2s, .2s, .35s',
    transitionTimingFunction    : 'linear, linear, ease',
    [theme.breakpoints.up('md')]: {
      width    : `calc(100% - ${drawerWidth}px)`,
      minHeight: '100vh',
    },
    overflow         : 'auto',
    position         : 'relative',
    float            : 'right',
    ...transition,
    maxHeight        : '100%',
    width            : '100%',
    overflowScrolling: 'touch',
  },
  content: {
    fontFamily                  : 'Montserrat',
    marginTop                   : '32px',
    padding                     : theme.spacing(1),
    display                     : 'flex',
    flexDirection               : 'column',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
      height : '100%',
    },
  },
}));
